var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "auto"
    }
  }, [_c('core-chart-chart-js-line-chart', {
    attrs: {
      "datasets": _vm.datasets,
      "labels": _vm.labels,
      "options": _vm.options,
      "height": 250
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };